export const filterAvailableUsers = (usersBySite: any[]) =>
  usersBySite.reduce((acc, user) => {
    return user?.relation?.toUpperCase() !== 'OWNER' ||
      acc.find((u: any) => u?.partyId === user?.partyId)
      ? acc
      : [...acc, user]
  }, [] as any[])
